export class IUserRating {
    public date: Date;
    public rating?: number;
    public comment?: string;
    public skipped: boolean;
}
